<template>
  <vs-popup
    title="Medicare Details"
    :active.sync="localVisible"
    class="medicare-modal"
  >
    <div class="px-6 py-4">
      <h5 class="text-xl font-semibold mb-4">Medicare/IHI</h5>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-teal-600 mb-1">Medicare Card Number</label>
        <p class="text-gray-900">{{ displayMedicareNumber || 'N/A' }}</p>
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-teal-600 mb-1">Individual Reference Number (IRN)</label>
        <p class="text-gray-900">{{ medicareData.medicareRefNumber || 'N/A' }}</p>
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-teal-600 mb-1">Valid to</label>
        <p class="text-gray-900">{{ medicareData.medicareExpiryDate || 'N/A' }}</p>
      </div>
      <hr class="border-gray-200 my-4" />
      <div class="flex flex-col">
        <label class="text-sm font-medium text-teal-600 mb-1">IHI Number</label>
        <p class="text-gray-900">{{ displayIHINumber || 'N/A' }}</p>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { formatIHINumber, formatMedicareNumber } from '@/utils/healthTreatment';

export default {
  name: 'MedicareDetailsDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    medicareData: {
      type: Object,
      default: () => ({
        medicareCardName: '',
        medicareNumber: '',
        medicareRefNumber: '',
        medicareExpiryDate: '',
        ihiNumber: '',
      }),
    },
  },
  computed: {
    localVisible: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.$emit('update:is-visible', value);
      },
    },
    displayIHINumber() {
      return formatIHINumber(this.medicareData.ihiNumber);
    },
    displayMedicareNumber() {
      return formatMedicareNumber(this.medicareData.medicareNumber);
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.medicare-modal {
  .vs-popup {
    max-width: 500px;
  }
}
</style>
